export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
export const MONTH = 31 * DAY;

export const units = {
  seconds: SECOND,
  minutes: MINUTE,
  hours: HOUR,
  days: DAY,
  weeks: WEEK,
  months: MONTH,
};